import type { ToolTestRun } from '../../lib/api';
import { ToolTestErrorCard } from './ToolTestErrorCard';
import { ToolTestResponseCard } from './ToolTestResponseCard';
import { ToolTestSourceResponseCard } from './ToolTestSourceResponseCard';

/** Renders one completed run, retaining any upstream response captured before an engine error. */
export const ToolTestRunView = ({ run }: { run: ToolTestRun }) =>
  'error' in run.result ? (
    <>
      <ToolTestErrorCard error={run.result} />
      {run.sourceResponse && <ToolTestSourceResponseCard sourceResponse={run.sourceResponse} />}
    </>
  ) : (
    <ToolTestResponseCard result={run.result} sourceResponse={run.sourceResponse} />
  );
